import { createStore } from 'vuex'

export default createStore({
  state: {
    mediaUri: "media-i.xlxhs.cn/guanwang"
  },
  getters: {
    mediaPath: (state) => (path) => {
      if (path.startsWith('/')) {
        path = path.substring(1)
      }

      let uri = state.mediaUri

      if (uri.endsWith('/')) {
        uri = uri.substring(0, uri.length - 1)
      }

      return `${window.location.protocol}//${uri}/${path}`
    }
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
